import React, {useState,useEffect} from 'react';
import {Breadcrumb,screenType} from './myFunctions';
import SearchResultsListLastName from './SearchResultsListLastName';
import SearchResultsListFirstName from './SearchResultsListFirstName';
import SearchResultsListMaidenName from './SearchResultsListMaidenName';
import SearchResultsListNickName from './SearchResultsListNickName';
import { v4 as uuidv4 } from 'uuid';  // see https://stackoverflow.com/questions/62549457/error-err-package-path-not-exported-package-subpath-v4-is-not-defined-by
export default function Search({list,oym,passedSearchItem,setSearchItem,dropBreadcrumb,authenticated}) {
    let objectList=list.map(friend => oym.objectRef(friend));
    
    // const [searchItem,setSearchItem] = useState (lastSearchItem);
    console.log("passed search item:"+passedSearchItem);
    // const [searchItem,localSetSearchItem] = useState("");
    function keyStroke(event) {
        console.log(event.target.value);
        console.log("about to set app serch item.  Will be "+event.target.value+" passedSearchItem:"+passedSearchItem);
        setSearchItem(event.target.value);
        console.log("Finished setting search items. Will I get this far? passedSearchItem:"+passedSearchItem);
    }

    let maidenNameNickName = (screenType()!=="Small") ? 
        (<>
            <td  valign="top" >
            <table>
                <tr><th>Maiden name</th></tr>
                <tr>
                    <td>
                        <SearchResultsListMaidenName key={uuidv4()} searchItem={passedSearchItem} list={list} oym={oym} dropBreadcrumb={dropBreadcrumb}/>
                    </td>
                </tr>
            </table>
        </td>
        <td  valign="top" >
            <table>
                <tr><th>Nick name</th></tr>
                <tr>
                    <td>
                        <SearchResultsListNickName key={uuidv4()} searchItem={passedSearchItem} list={list} oym={oym} dropBreadcrumb={dropBreadcrumb}/>
                    </td>
                </tr>
            </table>
        </td>
        </>) 
        : (<></>);
    return (
        <center>
        <h2>Search</h2>
        <label for="nameSearch">Enter name:</label>
        <input type="search" autoFocus id="nameSearch" name="search" onChange={keyStroke} value={passedSearchItem}></input> 
        {/* {searchResults} */}
        <table>
            <tr> 
                <td valign="top" >
                    <table>
                    <tr><th>Surname</th></tr>
                        <tr>
                            <td>
                                <SearchResultsListLastName key={uuidv4()} searchItem={passedSearchItem} list={list} oym={oym} dropBreadcrumb={dropBreadcrumb}/>
                            </td>
                        </tr>
                    </table>
                </td>
                
                <td  valign="top" >
                    <table>
                        <tr><th>Given name</th></tr>
                        <tr>
                            <td>
                                <SearchResultsListFirstName key={uuidv4()} searchItem={passedSearchItem} list={list} oym={oym} dropBreadcrumb={dropBreadcrumb}/>
                            </td>
                        </tr>
                    </table>
                </td>
                {maidenNameNickName}
            </tr>
        </table>
        </center>  
    )
}